module.exports = __webpack_public_path__ + "img/turnplate-border.c0c0a77b.png";